export const rafThrottle = (cb: () => void) => {
    let scheduled = false;

    return () => {
        if (scheduled) return;

        scheduled = true;

        requestAnimationFrame(() => {
            scheduled = false;
            cb();
        });
    };
};
